// src/types/evaluationCriteria.ts
export const EVALUATION_CRITERIA = {
  technical: 'Technical Ability',
  tactical: 'Tactical Awareness',
  physical: 'Physicality',
  speed: 'Speed',
  communication: 'Communication',
  work_rate: 'Work Rate',
  gk_shot_stopping: 'GK - Shot Stopping',
  gk_distribution: 'GK - Distribution',
} as const; // Use 'as const' for stricter typing

export type EvaluationCategory = keyof typeof EVALUATION_CRITERIA;

export const TEAM_LEVELS = ['Rec', 'Alliance', 'Elite', 'Premier'] as const;
export type TeamLevel = (typeof TEAM_LEVELS)[number]; // Type for team levels
